import { FormGroup, AbstractControl } from '@angular/forms';

export function reservationSetSupplieValidator(control: FormGroup) {
  if (control.value) {
    let isValid = true;
    const select = control.get('Select').value;
    const agreementPriceId = control.get('AgreementPriceId').value;
    if (select && !agreementPriceId) {
      isValid = false;
    }
    if (isValid) {
      return null;
    } else {
      return { invalidAgreementPriceId: true };
    }
  }
}
